(function(app) {
    document.addEventListener('DOMContentLoaded', function () {
        const builderData = JSON.parse(window.builderData);
        const components = builderData.components || [];
        const options = builderData.options || {};
        const defaultComponents = [
            'DataManager',
            'CartIntegration',
            'DiscountSlider',
            'TextMeasurement',
            'Utils',
            'VariableProduct',
            'SetToggle'
        ];

        const availableComponents = [...new Set([...components, ...options, ...defaultComponents])];

        // Initialize store with all required state
        app.Store.init({
            basePrice: window.basePrice || 0,
            productId: window.productId,
            stickerElements: window.stickerElements || [],
            layers: window.layersData || [],
            textBoundingBox: window.textBoundingBox || {},
            discounts: window.productDiscountData || [{
                quantity: 1,
                discount: 0
            }],
            colorMap: window.colorMap || {},
            builderData: builderData,
            builderDefaultComponents: defaultComponents,
            builderAvailableComponents: availableComponents,
            builderType: window.builderType || 'none',
            flagPosition: window.flagPosition || 'left',
            'text-maxwidth': window.textMaxWidth || 0,
            'text-maxheight': window.textMaxHeight || 0,
        });

        // Initialize all components
        let appComponents = [];
        availableComponents.forEach(component => {
            const appComponent = app[component];
            if (!appComponent) {
                return;
            }

            if (options[component]) {
                appComponent.options = options[component];
            }

            appComponents.push(appComponent);
        });

        // Sort components by priority (higher first)
        appComponents.sort((a, b) => (b.priority || 0) - (a.priority || 0));

        // Call init on all appComponents
        appComponents.forEach(component => {
            component?.init && typeof component.init === 'function' && component.init();
        });

        // Setup add to cart button
        setupAddToCartButton();

        // Set cart ready state
        app.Store.setState('cartReady', true);


        /**
         * Collect price data from all components
         * @returns {object} The complete price data
         */
        app.collectPriceData = () => {
            console.log('collecting from datamanager...')
            return app.DataManager ? app.DataManager.getPriceData() : {};
        };

        /**
         * Collect cart data from all components
         * @returns {object} The complete cart data
         */
        app.collectCartData = () => {
            return app.DataManager ? app.DataManager.getCartData() : {};
        }

        /**
         * Set up the add to cart button functionality using store state
         */
        function setupAddToCartButton() {
            const addToCartBtn = document.querySelector('.wdatca-button');
            const legacyAddToCartForm = document.querySelector('.variations_form.cart');
            const hiddenForm = document.querySelector('.wdpp-hidden-form');
            const productDataField = document.querySelector('.product-data-field');

            if (addToCartBtn && hiddenForm && productDataField) {
                addToCartBtn.onclick = () => {

                    if(window.wc_variation_data && legacyAddToCartForm){
                        legacyAddToCartForm.submit()
                    } else {

                        // Update product data field
                        const cartData = app.collectCartData();
                        productDataField.value = JSON.stringify(cartData);

                        // Update quantity
                        const quantityInput = document.querySelector('.wdatca-quantity-wrapper input[name="quantity"]');
                        const hiddenQuantityInput = hiddenForm.querySelector('input[name="quantity"]');
                        if (quantityInput && hiddenQuantityInput) {
                            hiddenQuantityInput.value = quantityInput.value;
                        }

                        // Submit the form natively (like WooCommerce)
                        hiddenForm.submit();

                    }
                };
            }
		}

        // Make the collectCartData function available to other modules if needed
        app.ProductPage = {
            collectCartData: app.collectCartData,
            collectPriceData: app.collectPriceData
        };

        // Debugging: Toggle canvas debug mode
        const btn = document.querySelector('.toggle-canvas-debug');
        if (btn) {
            btn.addEventListener('click', function() {
                app.CanvasRenderer.toggleDebugMode();
            });
        }
        
        // Debugging: Toggle flag position (left/right)
        const flagPositionBtn = document.querySelector('.toggle-flag-position');
        if (flagPositionBtn) {
            flagPositionBtn.addEventListener('click', function() {
                const currentPosition = app.Store.getState('flagPosition');
                const newPosition = currentPosition === 'left' ? 'right' : 'left';
                app.Store.setState('flagPosition', newPosition);
                flagPositionBtn.textContent = `Flag: ${newPosition}`;
            });
            // Set initial button text
            flagPositionBtn.textContent = `Flag: ${app.Store.getState('flagPosition')}`;
        }

        // Set initialization state
        app.Store.setState('initialized', true);
        
        // For all products, trigger an initial price calculation
        // This ensures "none" products also get their prices calculated
        setTimeout(() => {
            if (app.Utils && app.Utils.debouncedCalculatePriceAjax) {
                app.Utils.debouncedCalculatePriceAjax();
            }
        }, 100);
    });
})(window.app = window.app || {});